import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import ImprovedFooter from './ImprovedFooter';
import ScrollToTop from './ScrollToTop';
import NewsTicker from '../common/NewsTicker';

const Layout = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <NewsTicker />
      <main
        key={location.pathname + location.search}
        className="flex-grow animate-fade-in-up"
      >
        <Outlet />
      </main>
      <ImprovedFooter />
    </div>
  );
};

export default Layout;
